import React, { useState, FormEvent } from "react";
import { useNavigate } from "react-router-dom";

const RegisterPage = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");

  const navigate = useNavigate();

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setMessage("");

    try {
      const response = await fetch("https://has-backend-c48d669d897f.herokuapp.com/user/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, password }),
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Registration failed");

      setMessage("Registration successful! Redirecting...");
      setTimeout(() => navigate("/"), 2000); // Redirect after success
    } catch (err: any) {
      setMessage(err.message);
    }
  };

  return (
    <div className="flex flex-row items-center w-screen h-screen">

      <div className="w-1/2 flex justify-end items-center h-screen ">
        <div className="flex flex-col items-center justify-end h-[90%] w-[85%] rounded-md shadow-md mx-auto bg-gradient-to-t from-[#A3C1D1] to-[#FFFFFF] ">
          <h2 className="font-playfair text-white text-2xl">Crea una cuenta con nosotros en unos cuantos pasos</h2>
          <p className="text-base font-sourceSans text-gray-600">Completa estos sencillos pasos para registrarse y empezar a aprender</p>
          <div className="flex flex-col items-center w-full gap-4 mb-24 mt-6">
            <div className="flex flex-row w-1/2 py-2 bg-[#1c1c2e] gap-5 rounded-lg shadow-md">
              <div className="bg-white font-sourceSans rounded-full h-6 w-6 flex flex-col items-center justify-center ml-4" ><p>1</p></div>
              <p className="text-white font-sourceSans">Inscribe tu cuenta</p>
            </div>
            <div className="flex flex-row w-1/2 py-2 bg-[#ffffff] gap-5 rounded-lg shadow-md">
              <div className="bg-white font-sourceSans rounded-full h-6 w-6 flex flex-col items-center justify-center ml-4" ><p>2</p></div>
              <p className="text-black font-sourceSans">Paga tu primer módulo</p>
            </div>
            <div className="flex flex-row w-1/2 py-2 bg-[#ffffff] gap-5 rounded-lg shadow-md">
              <div className="bg-white font-sourceSans rounded-full h-6 w-6 flex flex-col items-center justify-center ml-4" ><p>3</p></div>
              <p className="text-black font-sourceSans">Inicia sesión y empieza a aprender</p>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col w-1/2 items-center">
        <div className="flex flex-col items-center">
          <h2 className="font-playfair mb-1 text-3xl">Inscribe tu cuenta</h2>
          <p className="font-sourceSans">Ingresa los siguientes datos para crear tu cuenta.</p>
        </div>

        <form className="mt-12 flex flex-col w-full items-center" onSubmit={handleSubmit}>
          <div className="flex flex-col w-1/2 items-start">
            <label className="font-sourceSans mb-1">Nombre completo</label>
            <input className="border border-[#8E8E8E] rounded-md bg-[#FAFAFA] w-full shadow-lg py-2 mb-4" type="text" value={name} onChange={(e) => setName(e.target.value)} required />
          </div>
          <div className="flex flex-col w-1/2 items-start">
            <label className="font-sourceSans mb-1">Correo electrónico</label>
            <input className="border border-[#8E8E8E] rounded-md bg-[#FAFAFA] w-full shadow-lg py-2 mb-4" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div className="flex flex-col w-1/2 items-start">
            <label className="font-sourceSans mb-1">Contraseña</label>
            <input className="border border-[#8E8E8E] rounded-md bg-[#FAFAFA] w-full shadow-lg py-2 mb-4" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>
          <div className="flex flex-col w-1/2 items-end">
            <p className="font-sourceSans text-sm ">Debe tener al menos 8 caracteres</p>
          </div>
          <button className="bg-[#1c1c2e] border border-[#8E8E8E] rounded-lg text-white font-sourceSans w-1/2 shadow-lg py-2 mt-12" type="submit">Registrarse</button>
        </form>
      </div>

    </div>
  );
};

export default RegisterPage;
